import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ReorderService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  update(type: string, ranks: any[] | {}, context?: { relatedToType: string; relatedToId: number }): Observable<any[]> {
    return this.httpClient.post<any>(`reorders`, {
      reorder: {
        reorder_type: type,
        ids_to_ranks: ranks,
        ...(context && { related_to_type: context.relatedToType, related_to_id: context.relatedToId }),
      },
    });
  }
}
